var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var SocialX20 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '20px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", style: svgStyle },
            React.createElement("g", { clipPath: "url(#Social_X_20_svg__clip0_5054_698)" },
                React.createElement("path", { d: "M11.1428 9.08175L15.6108 4H14.5524L10.6712 8.41151L7.5736 4H4L8.6852 10.6716L4 16H5.0584L9.1544 11.3403L12.4264 16H16M5.4404 4.78095H7.0664L14.5516 15.2574H12.9252" })),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "Social_X_20_svg__clip0_5054_698" },
                    React.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4 4)" }))))));
};
SocialX20.displayName = 'SocialX20';
export default SocialX20;
//# sourceMappingURL=social-x-20.js.map